/**
 * @file tool to dynamically load data from files
 * @author Haonan Yu(haoyu@microStrategy.com)
 */
import lin11_6_09_FeatureDependencies from '../assets/MSTR11_6_09/LINUX/Lin21FeatureDependencies.json';
import lin11_6_06_FeatureDependencies from '../assets/MSTR11_6_06/LINUX/Lin21FeatureDependencies.json';
import lin11_6_03_FeatureDependencies from '../assets/MSTR11_6_03/LINUX/Lin21FeatureDependencies.json';
import lin11_5_12_FeatureDependencies from '../assets/MSTR11_5_12/LINUX/Lin21FeatureDependencies.json';
import lin11_5_09_FeatureDependencies from '../assets/MSTR11_5_09/LINUX/Lin21FeatureDependencies.json';
import lin11_5_06_FeatureDependencies from '../assets/MSTR11_5_06/LINUX/Lin21FeatureDependencies.json';
import lin11_5_03_FeatureDependencies from '../assets/MSTR11_5_03/LINUX/Lin21FeatureDependencies.json';
import lin11_4_12_FeatureDependencies from '../assets/MSTR11_4_12/LINUX/Lin21FeatureDependencies.json';

import {
    featureDirectory2StateMap as lin11_6_09_FeatureDirectory2StateMap,
    featureKey2StateMap as lin11_6_09_FeatureKey2StateMap,
} from '../assets/MSTR11_6_09/LINUX/Lin21Maps';

import {
    featureDirectory2StateMap as lin11_6_06_FeatureDirectory2StateMap,
    featureKey2StateMap as lin11_6_06_FeatureKey2StateMap,
} from '../assets/MSTR11_6_06/LINUX/Lin21Maps';

import {
    featureDirectory2StateMap as lin11_6_03_FeatureDirectory2StateMap,
    featureKey2StateMap as lin11_6_03_FeatureKey2StateMap,
} from '../assets/MSTR11_6_03/LINUX/Lin21Maps';

import {
    featureDirectory2StateMap as lin11_5_12_FeatureDirectory2StateMap,
    featureKey2StateMap as lin11_5_12_FeatureKey2StateMap,
} from '../assets/MSTR11_5_12/LINUX/Lin21Maps';

import {
    featureDirectory2StateMap as lin11_5_09_FeatureDirectory2StateMap,
    featureKey2StateMap as lin11_5_09_FeatureKey2StateMap,
} from '../assets/MSTR11_5_09/LINUX/Lin21Maps';

import {
    featureDirectory2StateMap as lin11_5_06_FeatureDirectory2StateMap,
    featureKey2StateMap as lin11_5_06_FeatureKey2StateMap,
} from '../assets/MSTR11_5_06/LINUX/Lin21Maps';

import {
    featureDirectory2StateMap as lin11_5_03_FeatureDirectory2StateMap,
    featureKey2StateMap as lin11_5_03_FeatureKey2StateMap,
} from '../assets/MSTR11_5_03/LINUX/Lin21Maps';

import {
    featureDirectory2StateMap as lin11_4_12_FeatureDirectory2StateMap,
    featureKey2StateMap as lin11_4_12_FeatureKey2StateMap,
} from '../assets/MSTR11_4_12/LINUX/Lin21Maps';

import lin11_6_09_Comment from '../assets/MSTR11_6_09/LINUX/Lin21GeneratorComment';
import lin11_6_06_Comment from '../assets/MSTR11_6_06/LINUX/Lin21GeneratorComment';
import lin11_6_03_Comment from '../assets/MSTR11_6_03/LINUX/Lin21GeneratorComment';
import lin11_5_12_Comment from '../assets/MSTR11_5_12/LINUX/Lin21GeneratorComment';
import lin11_5_09_Comment from '../assets/MSTR11_5_09/LINUX/Lin21GeneratorComment';
import lin11_5_06_Comment from '../assets/MSTR11_5_06/LINUX/Lin21GeneratorComment';
import lin11_5_03_Comment from '../assets/MSTR11_5_03/LINUX/Lin21GeneratorComment';
import lin11_4_12_Comment from '../assets/MSTR11_4_12/LINUX/Lin21GeneratorComment';

import {
    state2PrefixMap as lin11_6_09_State2PrefixMap,
    state2CommentMap as lin11_6_09_State2CommentMap,
} from '../assets/MSTR11_6_09/LINUX/Lin21Maps4Generator';

import {
    state2PrefixMap as lin11_6_06_State2PrefixMap,
    state2CommentMap as lin11_6_06_State2CommentMap,
} from '../assets/MSTR11_6_06/LINUX/Lin21Maps4Generator';

import {
    state2PrefixMap as lin11_6_03_State2PrefixMap,
    state2CommentMap as lin11_6_03_State2CommentMap,
} from '../assets/MSTR11_6_03/LINUX/Lin21Maps4Generator';

import {
    state2PrefixMap as lin11_5_12_State2PrefixMap,
    state2CommentMap as lin11_5_12_State2CommentMap,
} from '../assets/MSTR11_5_12/LINUX/Lin21Maps4Generator';

import {
    state2PrefixMap as lin11_5_09_State2PrefixMap,
    state2CommentMap as lin11_5_09_State2CommentMap,
} from '../assets/MSTR11_5_09/LINUX/Lin21Maps4Generator';

import {
    state2PrefixMap as lin11_5_06_State2PrefixMap,
    state2CommentMap as lin11_5_06_State2CommentMap,
} from '../assets/MSTR11_5_06/LINUX/Lin21Maps4Generator';

import {
    state2PrefixMap as lin11_5_03_State2PrefixMap,
    state2CommentMap as lin11_5_03_State2CommentMap,
} from '../assets/MSTR11_5_03/LINUX/Lin21Maps4Generator';

import {
    state2PrefixMap as lin11_4_12_State2PrefixMap,
    state2CommentMap as lin11_4_12_State2CommentMap,
} from '../assets/MSTR11_4_12/LINUX/Lin21Maps4Generator';

import lin11_6_09_PageObjects from '../assets/MSTR11_6_09/LINUX/Lin21PageObjects.json';
import lin11_6_06_PageObjects from '../assets/MSTR11_6_06/LINUX/Lin21PageObjects.json';
import lin11_6_03_PageObjects from '../assets/MSTR11_6_03/LINUX/Lin21PageObjects.json';
import lin11_5_12_PageObjects from '../assets/MSTR11_5_12/LINUX/Lin21PageObjects.json';
import lin11_5_09_PageObjects from '../assets/MSTR11_5_09/LINUX/Lin21PageObjects.json';
import lin11_5_06_PageObjects from '../assets/MSTR11_5_06/LINUX/Lin21PageObjects.json';
import lin11_5_03_PageObjects from '../assets/MSTR11_5_03/LINUX/Lin21PageObjects.json';
import lin11_4_12_PageObjects from '../assets/MSTR11_4_12/LINUX/Lin21PageObjects.json';

import lin11_6_09_States from '../assets/MSTR11_6_09/LINUX/Lin21States.json';
import lin11_6_06_States from '../assets/MSTR11_6_06/LINUX/Lin21States.json';
import lin11_6_03_States from '../assets/MSTR11_6_03/LINUX/Lin21States.json';
import lin11_5_12_States from '../assets/MSTR11_5_12/LINUX/Lin21States.json';
import lin11_5_09_States from '../assets/MSTR11_5_09/LINUX/Lin21States.json';
import lin11_5_06_States from '../assets/MSTR11_5_06/LINUX/Lin21States.json';
import lin11_5_03_States from '../assets/MSTR11_5_03/LINUX/Lin21States.json';
import lin11_4_12_States from '../assets/MSTR11_4_12/LINUX/Lin21States.json';

import lin11_6_09_SummaryStructure from '../assets/MSTR11_6_09/LINUX/Lin21SummaryStructure.json';
import lin11_6_06_SummaryStructure from '../assets/MSTR11_6_06/LINUX/Lin21SummaryStructure.json';
import lin11_6_03_SummaryStructure from '../assets/MSTR11_6_03/LINUX/Lin21SummaryStructure.json';
import lin11_5_12_SummaryStructure from '../assets/MSTR11_5_12/LINUX/Lin21SummaryStructure.json';
import lin11_5_09_SummaryStructure from '../assets/MSTR11_5_09/LINUX/Lin21SummaryStructure.json';
import lin11_5_06_SummaryStructure from '../assets/MSTR11_5_06/LINUX/Lin21SummaryStructure.json';
import lin11_5_03_SummaryStructure from '../assets/MSTR11_5_03/LINUX/Lin21SummaryStructure.json';
import lin11_4_12_SummaryStructure from '../assets/MSTR11_4_12/LINUX/Lin21SummaryStructure.json';

import {
    LINUX_11_6_09,
    LINUX_11_6_06,
    LINUX_11_6_03,
    LINUX_11_5_12,
    LINUX_11_5_09,
    LINUX_11_5_06,
    LINUX_11_5_03,
    LINUX_11_4_12,
} from './Constants';

export let featureDependencies; // Only for GA, not update
export let comment;
export let featureDirectory2StateMap; // Only for GA, not update
export let featureKey2StateMap; // Only for GA, not update
export let state2PrefixMap;
export let state2CommentMap;
export let pageObjects;
export let states;
export let summaryStructure; // Only for GA, not update

export const linLoadData = (installation) => {
    switch (installation) {
        case LINUX_11_6_09:
            featureDependencies = lin11_6_09_FeatureDependencies;
            comment = lin11_6_09_Comment;
            featureDirectory2StateMap = lin11_6_09_FeatureDirectory2StateMap;
            featureKey2StateMap = lin11_6_09_FeatureKey2StateMap;
            state2PrefixMap = lin11_6_09_State2PrefixMap;
            state2CommentMap = lin11_6_09_State2CommentMap;
            pageObjects = lin11_6_09_PageObjects;
            states = lin11_6_09_States;
            summaryStructure = lin11_6_09_SummaryStructure;
            break;
        case LINUX_11_6_06:
            featureDependencies = lin11_6_06_FeatureDependencies;
            comment = lin11_6_06_Comment;
            featureDirectory2StateMap = lin11_6_06_FeatureDirectory2StateMap;
            featureKey2StateMap = lin11_6_06_FeatureKey2StateMap;
            state2PrefixMap = lin11_6_06_State2PrefixMap;
            state2CommentMap = lin11_6_06_State2CommentMap;
            pageObjects = lin11_6_06_PageObjects;
            states = lin11_6_06_States;
            summaryStructure = lin11_6_06_SummaryStructure;
            break;
        case LINUX_11_6_03:
            featureDependencies = lin11_6_03_FeatureDependencies;
            comment = lin11_6_03_Comment;
            featureDirectory2StateMap = lin11_6_03_FeatureDirectory2StateMap;
            featureKey2StateMap = lin11_6_03_FeatureKey2StateMap;
            state2PrefixMap = lin11_6_03_State2PrefixMap;
            state2CommentMap = lin11_6_03_State2CommentMap;
            pageObjects = lin11_6_03_PageObjects;
            states = lin11_6_03_States;
            summaryStructure = lin11_6_03_SummaryStructure;
            break;
        case LINUX_11_5_12:
            featureDependencies = lin11_5_12_FeatureDependencies;
            comment = lin11_5_12_Comment;
            featureDirectory2StateMap = lin11_5_12_FeatureDirectory2StateMap;
            featureKey2StateMap = lin11_5_12_FeatureKey2StateMap;
            state2PrefixMap = lin11_5_12_State2PrefixMap;
            state2CommentMap = lin11_5_12_State2CommentMap;
            pageObjects = lin11_5_12_PageObjects;
            states = lin11_5_12_States;
            summaryStructure = lin11_5_12_SummaryStructure;
            break;
        case LINUX_11_5_09:
            featureDependencies = lin11_5_09_FeatureDependencies;
            comment = lin11_5_09_Comment;
            featureDirectory2StateMap = lin11_5_09_FeatureDirectory2StateMap;
            featureKey2StateMap = lin11_5_09_FeatureKey2StateMap;
            state2PrefixMap = lin11_5_09_State2PrefixMap;
            state2CommentMap = lin11_5_09_State2CommentMap;
            pageObjects = lin11_5_09_PageObjects;
            states = lin11_5_09_States;
            summaryStructure = lin11_5_09_SummaryStructure;
            break;
        case LINUX_11_5_06:
            featureDependencies = lin11_5_06_FeatureDependencies;
            comment = lin11_5_06_Comment;
            featureDirectory2StateMap = lin11_5_06_FeatureDirectory2StateMap;
            featureKey2StateMap = lin11_5_06_FeatureKey2StateMap;
            state2PrefixMap = lin11_5_06_State2PrefixMap;
            state2CommentMap = lin11_5_06_State2CommentMap;
            pageObjects = lin11_5_06_PageObjects;
            states = lin11_5_06_States;
            summaryStructure = lin11_5_06_SummaryStructure;
            break;
        case LINUX_11_5_03:
            featureDependencies = lin11_5_03_FeatureDependencies;
            comment = lin11_5_03_Comment;
            featureDirectory2StateMap = lin11_5_03_FeatureDirectory2StateMap;
            featureKey2StateMap = lin11_5_03_FeatureKey2StateMap;
            state2PrefixMap = lin11_5_03_State2PrefixMap;
            state2CommentMap = lin11_5_03_State2CommentMap;
            pageObjects = lin11_5_03_PageObjects;
            states = lin11_5_03_States;
            summaryStructure = lin11_5_03_SummaryStructure;
            break;
        case LINUX_11_4_12:
            featureDependencies = lin11_4_12_FeatureDependencies;
            comment = lin11_4_12_Comment;
            featureDirectory2StateMap = lin11_4_12_FeatureDirectory2StateMap;
            featureKey2StateMap = lin11_4_12_FeatureKey2StateMap;
            state2PrefixMap = lin11_4_12_State2PrefixMap;
            state2CommentMap = lin11_4_12_State2CommentMap;
            pageObjects = lin11_4_12_PageObjects;
            states = lin11_4_12_States;
            summaryStructure = lin11_4_12_SummaryStructure;
            break;
        default:
    }
};
